<template>
	<div id="app">
		<div class="app-content">
			<Header />
			<div class="container">
				<slot />
			</div>
		</div>

		<Footer />
	</div>
</template>

<script>
import Footer from "./Footer.vue";
import Header from "./Header.vue";

export default {
	name: "App",
	components: {
		Footer,
		Header,
	},
	computed: {
		version() {
			return process.env.VUE_APP_VERSION;
		},
	},
};
</script>
<style lang="scss">
html {
	height: 100%;
}
body {
	margin: 0;
}

#app {
	font-family: Poppins, Montserrat, Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
}
.app-content {
	flex: 1 0 auto;
}
.footer {
	flex-shrink: 0;
}
.container {
	display: flex;
	flex-direction: column;
	width: 100%;
	// height: 100%;
}

.container-main {
	background-color: white;
	margin: 0 auto 60px auto;
	max-width: 1100px;
	min-height: 300px;
	padding: 20px;
	// flex-grow: 1;
	flex: 1 1 0%;
	overflow-y: scroll;
}
</style>
